<template>
    <div class="footer">
<!--        <img src="../assets/footer-logo@2x.png" alt="Logo" class="footer&#45;&#45;image">-->
        <span class="footer__text" v-html="footerText"></span>
        <div class="footer-info">
          <span class="footer-info__content phone">
            <img src="../assets/phone.svg" alt="Phone" class="footer-info__content--image">
            <a class="footer-info__content--text" href="tel:347-713-7077">347-713-7077</a>
          </span>
          <span class="footer-info__content">
            <img src="../assets/form.svg" alt="Email" class="footer-info__content--image">
            <a class="footer-info__content--text" href="mailto:info@rentthelois.com">info@45e7.com</a>
          </span>

        </div>
    </div>
</template>

<script>
    export default {
        name: "Footer",
        data: () => ({
            footerText: 'Avenue Second Owner, LLC and Exclusive Sales and Marketing Agent fully support the principles of the <br> <a href="https://www.dos.ny.gov/press/2020/docs/FairHousingNotice_new.pdf?j=465853&amp;sfmc_sub=97792223&amp;l=122_HTML&amp;u=10033327&amp;mid=100004597&amp;jb=4" target="_blank">Fair Housing Act and the Equal Opportunity Act.</a>'
        })
    }
</script>

<style scoped>

</style>
